<template>
  <div :class="'ListAttributes-'+attributes_position">
    <div style="text-align:right;margin-left:6px" v-if="attributes_position && attributes_position == 'vertical'">
        <button v-if="expandList.length==0" @click="changeListToggle(1)" style="width: 35px;
          background: none;  border: none;  cursor: pointer;  margin-top: 10px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-down-square" viewBox="0 0 16 16">8
            <path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
          </svg>
        </button>
        <button v-if="expandList.length>0" @click="changeListToggle(0)" style="width: 35px;
          background: none;  border: none;  cursor: pointer;  margin-top: 10px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-up-square" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z"/>
          </svg>
        </button>
    </div>

    <!-- ================================================================================= -->
    <template v-if="attributes_position && attributes_position == 'vertical'">

      <form v-if="list_attributes && Object.keys(list_attributes).length > 0" id="formData" ref="formData" :class="[(fixik > 68) ? 'posFixed' : '', (scrollek == 'up') ? 'scroll-lower' : 'scroll-upper']">
        <div class="listRoll">
          <div class="md-list" style="overflow-y: hidden;">

            <template v-if="tree && Object.keys(tree).length>0">
              <template v-for="(attribute, attributeIndex) in tree">
                  <template v-if="!attribute['optional']">
                    <div class="md-list-item" :key="'standard'+attributeIndex">
                        <modTreeAttributes :attributeIndex="attributeIndex" :attribute="attribute" :expandList="expandList"/>
                    </div>
                  </template>
              </template>
            </template>

            <div v-if="$moreOptions" style="width: 100%; text-align: right;  padding: 0px 10px;">
              <span style="text-align: right;padding: 10px 0px; color: dodgerblue; cursor: pointer;" @click="showMoreOptions">{{(moreOptions) ? '-' : '+'}} {{ $t("opcje_zaawansowane") }}</span>
            </div>

            <template v-if="tree && Object.keys(tree).length>0 && moreOptions && $moreOptions">
              <template v-for="(attribute, attributeIndex) in tree">
                  <template v-if="attribute['optional']">
                    <div class="md-list-item" :key="'optional'+attributeIndex">
                        <modTreeAttributes :attributeIndex="attributeIndex" :attribute="attribute" :expandList="expandList"/>
                    </div>
                  </template>
              </template>
            </template>

            <!-- <template v-else>
              <template v-for="(attribute, attributeIndex) in list_attributes">
                <div class="md-list-item" v-if="selectedFilters && selectedFilters.includes(attributeIndex)" :key="attributeIndex">
                  <div class="md-list-item">
                    <div @click="ToggleList(attributeIndex)" class="btn title">
                      <span> {{attribute['translation'] }}
                      </span>
                      <svg style="margin: 0px;  padding: 0px;  position: relative;  right: 20px;  width: 20px;  top: 3px;  color: #797979;"
                        v-if="expandList.includes(attributeIndex) || attributes_position && attributes_position != 'vertical'"
                        xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                        <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                      </svg>

                      <svg v-else style="margin: 0px;  padding: 0px;  position: relative;  right: 20px;  width: 20px;  top: 3px;  color: #797979;"
                      xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                    </div>
                  </div>

                  <transition name="fade">
                    <div class="md-item" v-if="expandList.includes(attributeIndex)">
                      <template v-if="attribute['inputType'] == 'checkbox'">
                          <FormCheckBox
                          :inputType="attribute.inputType"
                          :params="attribute.parametrs"
                          :tabName="attributeIndex"
                          :suffix="(attribute.suffix) ? attribute.suffix : null"
                        />
                      </template>
                      <template v-if="attribute['inputType'] == 'slider'">
                          <FormSlider
                          :inputType="attribute.inputType"
                          :params="attribute.parametrs"
                          :tabName="attributeIndex"
                          :suffix="(attribute.suffix) ? attribute.suffix : null"
                          :interval="(attribute.interval) ? attribute.interval : null"
                        />
                      </template>
                    </div>

                  </transition>

                </div>
              </template>
            </template> -->

          </div>
        </div>
      </form>

    </template>
    <!-- ================================================================================= -->
    <template v-if="attributes_position && attributes_position == 'horizontal'">

      <form v-if="list_attributes && Object.keys(list_attributes).length > 0" id="formData" ref="formData" :class="(fixik > 34) ? 'posFixedHor' : ''" class="resizable" :style="{ height: height + 'px' }">
        <div class="listRoll" :style="{ height: (height-20) + 'px' }">
          <!-- <div class="md-list" :class="(scrollek == 'up') ? 'scroll-lower' : 'scroll-upper'" :style="{ height: height + 'px' }"> -->
          <div class="md-list" :style="{ height: (height-40) + 'px' }">
            <!-- <VueDragResize :isActive="true" :h="350" :x="0" :y="0" v-on:resizing="resize" v-on:dragging="resize" :sticks="['bm']" style="width:100%" :isDraggable="false"> -->
            <!-- <h3>Hello World!</h3> -->
            <!-- <p>{{ top }} х {{ left }} </p>
            <p>{{ width }} х {{ height }}</p> -->
            <template v-if="tree && Object.keys(tree).length>0">
              <template v-for="(attribute, attributeIndex) in tree">
                  <!-- <template v-if="!attribute['optional']"> -->
                    <div class="md-list-item" :class="'md_list_item_'+attributeIndex" :key="'standard'+attributeIndex" v-if="selectedFilters.includes(attributeIndex)">
                        <modTreeAttributesHorizon :attributeIndex="attributeIndex" :attribute="attribute" :expandList="expandList"/>
                    </div>
                  <!-- </template> -->
              </template>
            </template>
          <!-- </VueDragResize> -->

            <!-- <template v-for="(attribute, attributeIndex) in list_attributes">

              <template v-if="attribute.subgroup && Object.keys(attribute.subgroup).length>0">
                <div class="md-list-item" :key="attributeIndex">
                  <div class="card">
                    <div class="btn title"><span>{{ attribute['translation'] }}</span></div>
                    <div class="md-item">
                      <FormCheckBoxGroups
                        :subGroups="attribute['subgroup']"
                        :tabName="attributeIndex"
                        :inputType="list_attributes[attributeIndex]['inputType']"
                        :suffix="(list_attributes[attributeIndex]['suffix']) ? list_attributes[attributeIndex]['suffix'] : null"
                        :view="attributes_position"
                      />
                    </div>
                  </div>
                </div>
              </template>

              <template v-else>
                <div class="md-list-item" v-if="selectedFilters && selectedFilters.includes(attributeIndex)" :key="attributeIndex">
                  <div class="md-list-item-text">
                    <div class="btn title"><span>{{ attribute['translation'] }} {{ (attribute['translation_short']) ? ' - '+attribute['translation_short'] : '' }}</span></div>
                  </div>
                  <div class="md-item">
                    <template v-if="attribute['inputType'] == 'checkbox'">
                        <FormCheckBox
                        :inputType="attribute.inputType"
                        :params="attribute.parametrs"
                        :tabName="attributeIndex"
                        :suffix="(attribute.suffix) ? attribute.suffix : null"
                      />
                    </template>
                    <template v-if="attribute['inputType'] == 'slider'">
                        <FormSlider
                        :inputType="attribute.inputType"
                        :params="attribute.parametrs"
                        :tabName="attributeIndex"
                        :suffix="(attribute.suffix) ? attribute.suffix : null"
                        :interval="(attribute.interval) ? attribute.interval : null"
                      />
                    </template>
                  </div>
                </div>
              </template>

            </template> -->

          </div> <!-- md-list -->

        </div>
        <div class="resizer" @mousedown="startResize">
          <svg style="color:grey;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
          </svg>
          <svg style="color:grey;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg>
        </div>

        <!-- <div id="nav-scroll">
          <svg @click="changeScroll('up')" :class="(scrollek == 'down') ? '' : 'nonactive'"  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-square" viewBox="0 0 16 16">
            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
            <path d="M3.544 10.705A.5.5 0 0 0 4 11h8a.5.5 0 0 0 .374-.832l-4-4.5a.5.5 0 0 0-.748 0l-4 4.5a.5.5 0 0 0-.082.537"/>
          </svg>
          <svg @click="changeScroll('down')" style="transform: rotate(180deg);" :class="(scrollek == 'up') ? '' : 'nonactive'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-square" viewBox="0 0 16 16">
            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
            <path d="M3.544 10.705A.5.5 0 0 0 4 11h8a.5.5 0 0 0 .374-.832l-4-4.5a.5.5 0 0 0-.748 0l-4 4.5a.5.5 0 0 0-.082.537"/>
          </svg>
        </div> -->
      </form>

    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormCheckBox from './fields/FormCheckBox'
import FormSlider from './fields/FormSlider'
import FormCheckBoxGroups from './fields/FormCheckBoxGroups'
import modTreeAttributes from './modTreeAttributes'
import modTreeAttributesHorizon from './modTreeAttributesHorizon'
import VueDragResize from 'vue-drag-resize'
// import Parametrs from './Parametrs'

export default {
  name: "ListAttributes",
  props:['fixik'],
  data() {
    return {
      view: false,
      isActive: true,
      complex: null,
      expand: {},
      expandSingle: false,
      expandList: [],
      expandgroupList: [],
      group: '',
      moreOptions: false,
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      scrollek: 'down',
      height: 295,
      startY: 0,
      startHeight: 0,
      isResizing: false,
    };
  },
  components: {
    FormCheckBox, FormSlider, FormCheckBoxGroups, modTreeAttributes, modTreeAttributesHorizon, VueDragResize  // Parametrs,
  },
  computed: {
    ...mapGetters('products', ['tree','list_attributes','selectedFilters','attributes_position'])
  },
  methods: {
    showMoreOptions () {
      this.moreOptions = !this.moreOptions
    },
    changeListToggle (e) {
      if (e) {
        this.expandList = JSON.parse(JSON.stringify(this.selectedFilters))
      } else {
        this.expandList = []
      }
    },
    resize(newRect) {
        this.width = newRect.width;
        this.height = newRect.height;
        this.top = newRect.top;
        this.left = newRect.left;
    },
    changeScroll (it) {
      if (it === this.scrollek) {

      } else {
        this.scrollek = it
      }
    },
    startResize(e) {
      this.isResizing = true;
      this.startY = e.clientY;
      this.startHeight = this.height;

      document.addEventListener('mousemove', this.resize);
      document.addEventListener('mouseup', this.stopResize);
    },
    resize(e) {
      if (this.isResizing) {
        const diff = e.clientY - this.startY; // różnica od momentu kliknięcia
        this.height = Math.max(100, this.startHeight + diff); // minimalna wysokość: 100px
      }
    },
    stopResize() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.resize);
      document.removeEventListener('mouseup', this.stopResize);
    }
  },
  created() {
    this.$store.dispatch("products/load_attributes", [])
  }

  //---------------------------------------------------
};
</script>

<style>
.resizable {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px solid #ccc;
  position: relative;
  overflow: hidden;
  transition: height 0.2s ease;
}

.resizer {
  height: 15px;
  background-color: #aaa;
  cursor: ns-resize;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.resizable:active {
  transition: none; /* Wyłącz animację w trakcie przeciągania */
}

#nav-scroll {
  padding: 6px;
}
#nav-scroll svg{
  cursor: pointer;
}
#nav-scroll svg:hover{
  color:#448aff
}
.scroll-upper {
  height: 605px !important;
  -moz-transition: height 1s ease;
  -webkit-transition: height 1s ease;
  -o-transition: height 1s ease;
  transition: height 1s ease;
}
.scroll-lower {
  height: 300px !important;
  -moz-transition: height 1s ease;
  -webkit-transition: height 1s ease;
  -o-transition: height 1s ease;
  transition: height 1s ease;
}
.nonactive {
  color:#bbb
}
#nav-scroll svg.nonactive:hover{
  color:#bbb
}
.posFixed {
  position: fixed !important;
  top: 5px !important;
  width: 420px;
}
.posFixedHor {
  position: fixed !important;
  top: 0px !important;
  z-index: 2;
  background: #fafafa;
  width: 100%;
}
#formData {
  top: 0px;
  position: relative;
}
.ListAttributes, .ListAttributes-horizontal {
  width: 100%;
}
.ListAttributes-horizontal .listRoll  {
  overflow-x: auto;
  width: 100%;
  overflow-y: hidden;
}
.ListAttributes-horizontal .md-list-item, .ListAttributes-horizontal .vdr .md-list-item {
  margin: 5px;
  padding: 0px;
  border: 1px solid #c6c6c6;
  height: 100%;
  width: 275px;
  min-width: 275px;
  overflow-y: auto;
}
.ListAttributes-horizontal .md-list-item-text, .ListAttributes-horizontal .vdr .md-list-item-text {
  text-align: left;
  align-items: left;
    color: #183884;
    display: flex;
    flex-shrink: 0;
    justify-content: flex-start;
    position: relative;
    width: 100%;
}
.ListAttributes-horizontal .md-list {
margin: 0;
  padding: 8px 0;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: row;
  position: relative;
  list-style: none;
  height: 565px;
  /* max-height: 300px; */
}
.md_list_item_Grupa_Zasilaczy, .md_list_item_Montaz_wlasny, .md_list_item_Wyjscia_techniczne, .md_list_item_Zgodnosc_z_normami {
  width: 400px !important;
  min-width: 400px !important;
}

.ListAttributes, .ListAttributes-vertical {
  width: 420px;
}
.ListAttributes #formData button.md-button, .ListAttributes-vertical #formData button.md-button {
  display: inline-block;
  top: 10px;
  left: 118px;
}
.ListAttributes #formData > input, .ListAttributes-vertical #formData > input {
  position: absolute;
  left: 2px;
  padding: 0px 15px;
  font-size: 12px;
  color: brown;
}

.ListAttributes #formData button.md-button, .ListAttributes-vertical #formData button.md-button {
  position: relative;
}

.ListAttributes #formData .listRoll ul, .ListAttributes-vertical #formData .listRoll ul {
  background: none;
  margin-top: 3px;
  margin-bottom: 5px;
}
.ListAttributes #formData .listRoll ul li, .ListAttributes-vertical #formData .listRoll ul li {
  margin-bottom: 5px;
  background: #ffffff;
  list-style: none;
  margin: 4px;
}
.ListAttributes #formData .listRoll > ul > li, .ListAttributes-vertical #formData .listRoll > ul > li {
  /* margin-bottom: -2px; */
  border: 0.5px solid #ccc;
}

.ListAttributes .listRoll, .ListAttributes-vertical .listRoll  {
  max-height: 70vh;
  overflow-y: auto;
}

.ListAttributes .md-list-item, .ListAttributes-vertical .md-list-item {
  margin: 5px;
  padding: 0px;
  border: 1px solid #c6c6c6;
}
.ListAttributes .md-list-item:hover, .ListAttributes-vertical .md-list-item:hover {
  border: 1px solid #3d3d3d;
}
.ListAttributes .md-list-item-text, .ListAttributes-vertical .md-list-item-text {
  text-align: left;
  align-items: left;
    color: #183884;
    display: block;
    flex-shrink: 0;
    justify-content: flex-start;
    position: relative;
    width: 100%;
}

.ListAttributes .md-list, .ListAttributes-vertical .md-list {
  margin: 0;
  padding: 0px;
  display: block;
  flex-flow: row nowrap;
  position: relative;
  list-style: none;
}

.md-list-item-content {
  min-height: 35px;
  font-size: 14px;
}
.md-list-item-content > .md-icon:last-child {
  margin-left: 0px;
    transition: none
}

.md-list-item-text .btn {
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  float: left;
  padding: 8px;
}
.md-list-item-text .btn.title {
  width: 100%;
}
.md-list-item-text .btn.remove {
  width: 25px;
  text-align: center;
  color: red;
}
.md-list-item-text .btn.remove:hover {
  font-weight: bold;
}
.md-list-item-text .btn span {
  color: #6d6d6d;
  display: block;
  font-size: 14px;
  font-weight: 600;
  float: left;
}
.md-list-item-text .btn span em {
  color: #a5a5a5;
  margin-left: 10px;
  font-size: 10px;
  line-height: 18px;
}

.md-item-subgroup {
  width: 320px;
  color: #2c3e50;
  margin: 10px 25px;
}
.md-item-subgroup .card {
  line-height: 1.5em;
}
.md-list-item-subgroup .md-list-item-text .btn {
  padding: 10px 0px;
}

.md-item {
  margin:8px 10px;
  text-align: left;
  min-height: 75px;
  display: grid;
}
.md-item-group {
  margin:8px 0px;
  text-align: left;
}
.md-item-group-title{
  font-weight: 700;
  display: block;
  margin-bottom: 12px;
}
.active_title_group {
  color: red;
  background: green !important;
}
span.md-list-item-text {
  font-size: 14px;
  color: #646464;
  white-space: normal;
}

/* .fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
} */

.fade-enter-active {
  /* transition: all .3s ease; */
  animation: bounce-in .3s ease;
}
.fade-leave-active {
  /* animation: bounce-in .5s reverse; */
  transition: all .3s ease;
  /* transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
}
.fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
@keyframes bounce-in {
  0% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}


h4 {
  padding: 5px;
  margin: 0px;
}
h5 {
  margin: 2px 0px;
  font-size: 12px;
  font-weight: normal;
  height: 13px;
}

.emID {
  color: #999;
  font-size: 10px !important;
  margin-left: 3px;
  font-weight: normal;
}
.emCNT {
  color: #448aff;
  font-size: 10px !important;
  margin-left: 3px;
  font-weight: normal;
}

ul.ListParametrs {
  padding: 0px;
  margin: 0px 20px;
}
ul.TemplateParametrs {
  padding: 0px;
  margin: 0px 20px;
}


.margin {
  height: 8px;
  display: block;
}

div.parametr li.md-list-item.podgrupa div.md-list-item-expand.md-list-item-container.md-button-clean.md-active div.md-list-expand ul.md-list.md-theme-default li.md-list-item.md-inset.listaPodgrupa div.md-list-item-default.md-list-item-container.md-button-clean div.md-list-item-content.md-ripple.md-disabled {
padding: 0px 15px;
height: 15px;
min-height: 24px;
line-height: 12px;
display: block;
}

div.parametr li.md-list-item.podgrupa .md-list-item-expand {
    border-top: 1px solid transparent;
        border-top-color: transparent;
    border-bottom: 0px solid transparent;
        border-bottom-color: transparent;
    transition: none
}
html.md-theme-default body div#app div.home div.content nav.menu div.ListAttributes form#formData div.listRoll ul.md-list.md-theme-default li.md-list-item div.md-list-item-expand.md-list-item-container.md-button-clean.md-active div.md-list-expand ul.md-list.md-theme-default ul.TemplateParametrs div.parametr li.md-list-item.podgrupa div.md-list-item-expand.md-list-item-container.md-button-clean.md-active div.md-list-expand ul.md-list.md-theme-default li.md-list-item.md-inset.listaPodgrupa div.md-list-item-default.md-list-item-container.md-button-clean div.md-list-item-content.md-ripple.md-disabled {
    transition: none
}
html.md-theme-default body div#app div.home div.content nav.menu div.ListAttributes form#formData div.listRoll ul.md-list.md-theme-default li.md-list-item div.md-list-item-expand.md-list-item-container.md-button-clean.md-active div.md-list-expand ul.md-list.md-theme-default ul.TemplateParametrs div.parametr li.md-list-item.podgrupa div.md-list-item-expand.md-list-item-container.md-button-clean.md-active div.md-list-expand ul.md-list.md-theme-default li.md-list-item.md-inset.listaPodgrupa {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ListAttributes.vue